import { translatableStringFactory } from "@@/shared/translations/translation";
import { z } from "zod";

const discountCodeZodString = z
    .string()
    .trim()
    .regex(
        /^\S+$/,
        translatableStringFactory({
            sv: "Koden får inte ha mellanslag",
            en: "The code can't have spaces",
        }),
    )
    .min(1)
    .max(
        50,
        translatableStringFactory({
            sv: "Koden får max vara 50 tecken",
            en: "The code can be max 50 characters",
        }),
    );

export { discountCodeZodString };
